import Common from "@/assets/js/common.js";
import ConfigUrl from "@/assets/js/configurl.js";
import Global from "@/assets/js/globalProperties.js";
import { Dialog } from 'vant';
//用户对象
var user = {
    //设置sessionid，为是否登录的标识，登录成功、验证登录成功，都会返回，需要存储
    setSessionId: function(sessionId) {
        sessionId = sessionId ? sessionId : '';
        Common.setCookie('sessionid', sessionId, '1d');
    },
    //设置IsCertified，为是否实名制的标识，登录成功、验证登录成功，都会返回，需要存储
    setIsCertified: function(isCertified) {
        isCertified = isCertified ? isCertified : '';
        sessionStorage.setItem('isCertified', isCertified);
    },
    //用户信息，验证登录的时候，会返回，需要存储
    setUserInfo(userInfoObj) {
        localStorage.setItem('userinfo', JSON.stringify(userInfoObj));
    },
    //是否登录
    isLogin: function() {
        var hasSession = Common.getCookie("sessionid") ? true : false;
        if (!hasSession) {
            // var userinfo = localStorage.getItem('userinfo');
            // if (!userinfo || userinfo == 'undefined') {
            //     return false;
            // } else {
            //     return true;
            // }
            return false;
        } else {
            return true;
        }
    },
    //是否实名制
    isCertified: function() {
        return sessionStorage.getItem('isCertified') ? true : false;
    },
    //登出，在验证失败，接口返回登录失效的时候调用
    logout: function() {
        Common.delCookieFn("sessionid");
    },
    //设置微信code，测试的时候会传入
    setCode: function(code) {
        localStorage.setItem("code", code);
    },
    //获取微信code，测试的时候会校验
    getCode: function() {
        return localStorage.getItem("code");
    },
    //微信登录
    wechatLogin: function(wechatLoginUrl, redirectPath, redirectParams = {}) {
        var redirectUrl = ConfigUrl.configUrl + redirectPath;
        if (Object.keys(redirectParams).length > 0) {
            redirectUrl += '?';
            var paramArray = []
            for (var i in redirectParams) {
                paramArray.push(`${i}=${redirectParams[i]}`);
            }
            redirectUrl += paramArray.join('&');
        }
        redirectUrl = encodeURIComponent(redirectUrl);
        wechatLoginUrl = wechatLoginUrl.replace(/(redirect_uri=)([^&]*)/gi, 'redirect_uri=' + redirectUrl);
        location.href = wechatLoginUrl;
    },
    //获取用户信息
    getUserInfo: function() {
        let SaleChannel = 8;
        if (process.env.NODE_ENV != 'development') {
            SaleChannel = Global.H5AppSaleChannel;
        }
        var requestParam = {
            ActionType: Global.laServiceUrl_ActionType_UserDetailInfo,
            Args: {
                SaleChannel: SaleChannel,
            }
        };
        Common.ajax({
            data: requestParam,
            success: function(data) {
                if (data.ErrorCode === 0) {
                    //用户是否实名验证
                    user.setIsCertified(data.Result.IsCertified);
                    //用户信息
                    user.setUserInfo(data.Result);
                }
                //服务器未正常返回内容
                else {
                    Dialog({
                        title: '提示',
                        message: '访问失败，请关闭程序后重试',
                    });
                }
            },
            error: function() {}
        });
    },
    //验证登录状态
    checkLogin: function(redirectPath, callBack) {
        let SaleChannel = 8;
        if (process.env.NODE_ENV != 'development') {
            SaleChannel = Global.H5AppSaleChannel;
        }
        var requestParam = {
            ActionType: Global.laServiceUrl_ActionType_UserDetailInfo,
            Args: {
                SaleChannel: SaleChannel,
            }
        };
        Common.ajax({
            data: requestParam,
            success: function(data) {
                // alert('code'+data.ErrorCode);
                //用户已登录
                if (data.ErrorCode === 0) {
                    // alert('ss:'+data.Result.SessionID+',cer:'+data.Result.IsCertified);
                    // user.setSessionId(data.Result.SessionID);
                    user.setIsCertified(data.Result.IsCertified);
                    // alert(data.Result);
                    // alert('code:'+user.getCode()+',login:'+user.isLogin()+',iscer:'+user.isCertified());
                    user.setUserInfo(data.Result);
                    callBack();
                }
                //其他类型错误
                else if (data.ErrorCode === 1) {
                    Dialog({
                        title: '提示',
                        message: data.Result
                    });
                }
                //未进行微信登录或微信登录超时
                else if (data.ErrorCode == 3) {
                    if (!data.Result.HasUnionId || !data.Result.LoginStatus) {
                        user.setCode(Common.getUrlQuery("code"));
                        console.log(21212)
                        user.wechatLogin(data.Result.WechatRedirectUrl, redirectPath, { actionType: data.Result.ActionType });
                    }
                }
                //服务器未正常返回内容
                else {
                    Dialog({
                        title: '提示',
                        message: '访问失败，请关闭程序后重试',
                    });
                }
            },
            error: function() {

            }
        });
    }
}

export default user;



// WEBPACK FOOTER //
// ./src/assets/js/user.js